import React,{useState,useContext} from "react";
import { useFormik } from "formik";
import { FarmerContext } from "./FarmerContext";
import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser} from '@fortawesome/free-solid-svg-icons';

export default function FarmerAccountChange(){
    const {farmersData,token,baseUrl}=useContext(FarmerContext)
    const [dataToEdit,setDataToEdit]=useState(false)
    const [previewSrc,setPreviewSrc]=useState(null)
    const navigate=useNavigate()
    
    const formik=useFormik({
        initialValues:{
          name:dataToEdit?.name ?dataToEdit?.name : farmersData?.name,
          email:dataToEdit?.email?dataToEdit?.email :farmersData?. email ,
          profile:dataToEdit?.profile?dataToEdit?.profile :farmersData?.profile 
        },
        validationSchema:Yup.object().shape({
            name:Yup.string().required("Name is required ").typeError("Name should be a string"),
            email:Yup.string("Email should be a string").email("Invalid email format").required("Email is required").typeError("Please enter avalid email"),
            profile:Yup.mixed().nullable()
        }),
        onSubmit:async(values,{setSubmitting})=>{
            try {
                if(dataToEdit){
                    await handleUpdateFarmer(values)
                    setDataToEdit(false)
                    formik.resetForm()
                }
            } catch (error) {
                console.error(`An error ocurred updating bank_owner data ${error}`)
            }
            finally{
                setSubmitting(false)
            }
        }
    })

    const handleUpdateFarmer=async(values)=>{
          try {
            const res=await fetch(`${baseUrl}/farmers/${farmersData?.id}`,{
                method:"PATCH",
                headers:{
                    "Content-Type": "application/json",
                    "Authorization":`Bearer ${token}`
                },
                body:JSON.stringify(values)
            })
            if (res.ok){
                alert(`Congratulations ${values?.name},you have successfuly updated your account`)
            }
            else{
                if (res.status===500){
                    alert(`An error ocurred updating your account,please try again`)
                }
                else{
                    const errorData=await res.json()
                    alert(`An error occurred updating your account : ${errorData?.Message || errorData?.Error}`)
                }
            }
          } catch (error) {
            console.error(`An error ocurred updation account ${error}`)
          }
    }

    const handleFileChange=async(event)=>{
     try {
        if(!event.currentTarget.files.length>0) return
    const file=event.currentTarget.files[0]
    const reader=new FileReader()
    formik.setFieldValue("profile",file)
    reader.onloadend=()=>{
        setPreviewSrc(reader?.result)
        }
    reader?.readAsDataURL(file) 
     }
      catch (error) {
        console.error(`An error ocurred upolading image ${error}`)
     }
    }

    return(
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center overflow-x-auto overflow-y-auto max-w-full mt-20">
      <div className="bg-white rounded-lg p-6 shadow-lg  sm:w-5/6  md:w-2/3 lg:w-1/2 max-h-full min-h-fit mb-16 w-full h-full mt-28">
        <div>
         <button className="flex items-center gap-3 rounded-full text-cyan-500 disabled:opacity-50">
        <ArrowLeftIcon strokeWidth={2} className="h-5 w-5" onClick={() => navigate(-1)} />Go Back
      </button>
      </div>
        <h2 className="text-lg font-bold mb-4">AdminAccount</h2>         
        <div className="">
                {farmersData?.profile?<img src={farmersData.profile} className=" h-40 w-40 rounded-full "/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full" />}
                {farmersData?.email?<p >{farmersData?.email}</p>:<p>{farmersData?.email} || loading email...</p>}
                {farmersData?.name?<p >{farmersData?.name}</p>:<p>{farmersData?.name} || loading name...</p>}
                <button className="max-w-full min-w-fit bg-blue-500 disabled:opacity-50 h-12 w-12  rounded-lg mb-6" onClick={()=>setDataToEdit(farmersData)}>Edit</button>
             </div>          
        {/* <Outlet /> */}
        {dataToEdit &&
         <form onSubmit={formik.handleSubmit} className="flex flex-col items-center bg-gray-100 min-w-fit">
        <section className=" flex flex-row space-x-3 justify-between">
        <label htmlFor="name" className='max-w-full min-w-fit font-bold mt-5 mb-4 text-lg mr-4'>Name</label>
        <input
          type="text"
          name="name"
          value={formik.values.name}
          placeholder="Change your name" 
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className='max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl'
          required
        />
        </section>
        {formik.touched.name && formik.errors.name && <p className='text-red-500 italic'>{formik.errors.name}</p>}
        
        <div className=" flex flex-row justify-between">
        <label htmlFor="email" className='max-w-full min-w-fit font-bold mt-4 mb-4 text-xl mr-4'>Email</label>
        <input
          type="email"
          name="email"
          value={formik.values.email}
          placeholder="Change your Email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className='max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl'
          required
        />
        </div >
        {formik.touched.email && formik.errors.email && <p className='text-red-500 italic'>{formik?.errors?.email}</p>}

        <div className=" flex flex-row justify-between ">
        <label htmlFor="profile_picture" className='max-w-full min-w-fit font-bold mt-4 mb-4 text-2xl mr-2'>Profile</label>
        <input
           type="file"
           accept="image/*" 
          name="profile"
          id="profile_picture"
          placeholder="Change profile"
         onChange={handleFileChange}
          onBlur={formik.handleBlur}
          className='max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl'
          // value={formik.values?.profile}
        />
        </div>
        {/* {formik.touched.name && formik.errors.name && <p className='text-red-500 italic'>{formik.errors.name}</p>} */}
        {previewSrc && 
             <img src={previewSrc} className=" h-20 w-20 rounded-full"/>
        }
        <button type="submit" className="max-w-full min-w-fit bg-blue-500 disabled:opacity-50 h-12 rounded-lg mb-6 mt-4" disabled={formik.isSubmitting || !formik.isValid}>ChangeValues</button>
        </form>}
      </div>
    </div>
    )
}
